var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgHandshake = function SvgHandshake(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.5L13 19.5C13.197 19.697 13.4308 19.8532 13.6882 19.9598C13.9456 20.0665 14.2214 20.1213 14.5 20.1213C14.7786 20.1213 15.0544 20.0665 15.3118 19.9598C15.5692 19.8532 15.803 19.697 16 19.5C16.197 19.303 16.3532 19.0692 16.4598 18.8118C16.5665 18.5544 16.6213 18.2786 16.6213 18C16.6213 17.7214 16.5665 17.4456 16.4598 17.1882C16.3532 16.9308 16.197 16.697 16 16.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5L16.5 17C16.8978 17.3978 17.4374 17.6213 18 17.6213C18.5626 17.6213 19.1022 17.3978 19.5 17C19.8978 16.6022 20.1213 16.0626 20.1213 15.5C20.1213 14.9374 19.8978 14.3978 19.5 14L15.62 10.12C15.0575 9.55821 14.295 9.24265 13.5 9.24265C12.705 9.24265 11.9425 9.55821 11.38 10.12L10.5 11C10.1022 11.3978 9.56259 11.6213 8.99998 11.6213C8.43737 11.6213 7.89781 11.3978 7.49998 11C7.10216 10.6022 6.87866 10.0626 6.87866 9.50002C6.87866 8.93741 7.10216 8.39784 7.49998 8.00002L10.31 5.19002C11.2222 4.28016 12.4119 3.70057 13.6906 3.54299C14.9694 3.38541 16.2641 3.65885 17.37 4.32002L17.84 4.60002C18.2658 4.857 18.772 4.94613 19.26 4.85002L21 4.50002",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.5L22 14.5H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5L2 14.5L8.5 21C8.89782 21.3978 9.43739 21.6213 10 21.6213C10.5626 21.6213 11.1022 21.3978 11.5 21C11.8978 20.6022 12.1213 20.0626 12.1213 19.5C12.1213 18.9374 11.8978 18.3978 11.5 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5H11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHandshake);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;